import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// SUPER ADMIN DASHBOARD APIS
// ================================

// 🔹 PLATFORM STATS
export async function getAdminDashboardStats() {
  try {
    const fd = new FormData();

    const response = await axios.post(
      `${apiBaseUrl}admin/dashboard/stats`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getAdminDashboardStats error:", error);
    return { status: false, type: "danger", success: "Failed to load dashboard stats" };
  }
}

// 🔹 REVENUE TREND
export async function getRevenueTrend() {
  try {
    const fd = new FormData();

    const response = await axios.post(
      `${apiBaseUrl}admin/dashboard/revenue-trend`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getRevenueTrend error:", error);
    return { status: false, type: "danger", success: "Failed to load revenue trend" };
  }
}

// 🔹 USAGE BREAKDOWN
export async function getUsageBreakdown() {
  try {
    const fd = new FormData();

    const response = await axios.post(
      `${apiBaseUrl}admin/dashboard/usage-breakdown`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getUsageBreakdown error:", error);
    return { status: false, type: "danger", success: "Failed to load usage data" };
  }
}

// 🔹 REVIEW VOLUME
export async function getReviewVolume() {
  try {
    const fd = new FormData();

    const response = await axios.post(
      `${apiBaseUrl}admin/dashboard/review-volume`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getReviewVolume error:", error);
    return { status: false, type: "danger", success: "Failed to load review volume" };
  }
}

// 🔹 RISK SIGNALS
export async function getRiskSignals() {
  try {
    const fd = new FormData();

    const response = await axios.post(
      `${apiBaseUrl}admin/dashboard/risk-signals`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getRiskSignals error:", error);
    return { status: false, type: "danger", success: "Failed to load risk signals" };
  }
}